import React, { useContext } from 'react';
import classNames from 'classnames';
import { SubCategoriesPropTypes } from '../../types/index';
import { AppContext } from '../context/listingsContext';
import { DesktopTopBar, TouchTopBar } from '../common/top_bar';
import NscTilesCarousel from '../common/nsc_tiles_carousel';
import TopFiltersCarousel from '../common/top_filters_carousel';
import BusinessListings from '../common/listings/BusinessListings';
import { getFilterTilesCarousel } from '../common/top_filters_carousel/utils';
import NestedSubcategoryNav from '../common/floating_topbar/nested_subcategory_nav';
import { shoudlShowTileCaoursel } from '../../abTestAllocations/navigationTilesSC/utils';
import Breadcrumbs from './breadcrumbs';
import SubcatHeader from './header';
import './index.scss';

const BusinessSubCategories = (props) => {

    const {
        displayData,
        appFilters
    } = props;

    const { isTouch, listings: [listings], categoryIds, inNavigationTilesSCTest, inNscIconsMobileWeb } = useContext(AppContext);
    const { header, breadcrumbs, categoryName, nestedSubCategoryName } = displayData;
    const { subCategory, activeFiltersQueryString } = appFilters;
    const allGigs = [ ...listings.gigs, ...listings.restOfGigs ];
    const isNestedSubcategory = !!nestedSubCategoryName;
    const { children } = subCategory;
    const nestedSubCategoryItems = children && children[0].children;
    const { nestedSubCategoryId, subCategoryId } = categoryIds || {};
    const subCatFiltersCarousel = getFilterTilesCarousel(subCategory.id, nestedSubCategoryId);

    return (
        <div className={classNames('sub-categories-page', { 'top-filters': !isTouch })}>
            <div className="row">
                <header>
                    {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs.slice(0, breadcrumbs.length - 1)}/>}
                    <SubcatHeader data={{ ...header, categoryName, scName: subCategory.name }}/>
                </header>
            </div>
            {
                !isNestedSubcategory && nestedSubCategoryItems &&
                    <div className="row">
                        {
                            (isTouch && !inNscIconsMobileWeb)?
                                <NestedSubcategoryNav subCategory={subCategory}
                                    isTouch={isTouch}
                                    activeFiltersQueryString={activeFiltersQueryString}/>
                                :
                                <NscTilesCarousel items={nestedSubCategoryItems}/>
                        }
                    </div>
            }
            {shoudlShowTileCaoursel({ isTouch, subCatFiltersCarousel, subCategoryId, inNavigationTilesSCTest }) &&
            <div className="row">
                <TopFiltersCarousel topFiltersCarousel={subCatFiltersCarousel} subCategoryId={subCategoryId}/>
            </div>
            }
            {
                isTouch ?
                    <TouchTopBar gigs={allGigs}/> :
                    <DesktopTopBar gigs={allGigs}/>
            }
            <BusinessListings/>
        </div>
    );
};

BusinessSubCategories.propTypes = SubCategoriesPropTypes;

export default BusinessSubCategories;
